import requests from "./httpService";


import getEmployeeId from "utils/commonAdmin";

// <-- Add this line


const AddonTypeServices = {
  addAddonType: async (body) => {
    const id_employee =await getEmployeeId(); 
    return requests.post(`/addons/add/${id_employee}`, body);
  },
  getAllAddonType: async (body) => {
    return requests.get(`/addons/`, body);
  },
  getAddonTypeById: async (id, body) => {
    return requests.get(`/addons/${id}`, body);
  },

  updateAddonType: async (id, body) => {
    const id_employee =await getEmployeeId(); 
    return requests.put(`/addons/update/${id}/${id_employee}`, body);
  },

  deleteAddonType: async (id) => {
    return requests.delete(`/addons/delete/${id}`);
  },
};

export default AddonTypeServices;
